import React from 'react';
import { USER_TESTIMONIALS } from '../data/userTestimonials.js';

/** Real quotes only — add to userTestimonials.js after written permission. */
export const UserTestimonialsSection = ({ className = '' }) => (
  <section
    id="user-testimonials"
    className={`bg-gray-50 rounded-lg shadow-md p-6 md:p-8 border border-gray-200 ${className}`.trim()}
    aria-labelledby="user-testimonials-heading"
  >
    <h2
      id="user-testimonials-heading"
      className="text-2xl font-bold text-gray-900 mb-2 text-center"
    >
      What users say
    </h2>
    <p className="text-sm text-gray-500 text-center mb-6">
      Quotes used with permission. Individual experiences only.
    </p>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
      {USER_TESTIMONIALS.map((t, i) => (
        <blockquote
          key={i}
          className="bg-white border-l-4 border-blue-500 pl-4 pr-4 py-3 rounded-r-lg shadow-sm"
        >
          <p className="text-gray-700 italic text-sm leading-relaxed">&ldquo;{t.quote}&rdquo;</p>
          <footer className="text-sm font-semibold text-gray-900 mt-2 not-italic">
            &mdash; {t.attribution}
          </footer>
        </blockquote>
      ))}
    </div>
  </section>
);

export default UserTestimonialsSection;
